import React, { createContext, ReactNode, useContext, useState } from "react";
import { getPropertyTabFromParams } from "_common/_utils/pageUtils";
import { PROPERTY_TABS } from "properties/propertyPage/PropertyContent";
import { useLocation } from "react-router-dom";

type PropertyTabsContextType = {
    propertyTabsSelected: PROPERTY_TABS;
    setPropertyTabs: (tab: PROPERTY_TABS) => void;
};

const PropertyTabsContext = createContext<PropertyTabsContextType | undefined>(undefined);

type PropertyTabsProviderProps = {
    children: ReactNode;
};

export const PropertyTabsProvider: React.FC<PropertyTabsProviderProps> = ({ children }: PropertyTabsProviderProps) => {
    const location = useLocation();

    const [propertyTabsSelected, setPropertyTabsSelected] = useState(
        getPropertyTabFromParams(location.search) ?? PROPERTY_TABS.DETAILS,
    );

    const setPropertyTabs = (tab: PROPERTY_TABS) => {
        setPropertyTabsSelected(tab);
    };

    return (
        <PropertyTabsContext.Provider value={{ propertyTabsSelected, setPropertyTabs }}>
            {children}
        </PropertyTabsContext.Provider>
    );
};

export const usePropertyTabs = () => {
    const context = useContext(PropertyTabsContext);
    if (!context) {
        throw new Error("usePropertyTabs must be used within a PropertyTabsProvider");
    }
    return context;
};
